<template>
  <button
    ref="button"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
    class="info-icon"
    aria-label="More information"
    type="button"
  >
    <theme-icon icon="info-icon" type="icons" />
  </button>
</template>

<script>
import ThemeIcon from './ThemeIcon.vue';
import { createTooltip, removeTooltip, loadTooltipContent } from './helpers/tooltipHelper';

export default {
  name: 'InfoIcon',
  
  components: {
    ThemeIcon
  },

  props: {
    identifier: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      tooltipElement: null
    }
  },

  methods: {
    async showTooltip() {
      const content = await loadTooltipContent(this.identifier);
      this.tooltipElement = createTooltip(this.$refs.button, content);
    },
    
    hideTooltip() {
      removeTooltip(this.tooltipElement);
      this.tooltipElement = null;
    }
  },
  
  beforeDestroy() {
    removeTooltip(this.tooltipElement);
  }
}
</script>

<style lang="less">
@import '../../../../less/theme/v1/components/info-icon.less';
</style>
